import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LogIn from "./components/userSignIn/User-Sign-In.js";
import ClippedDrawer from "./components/drawer/Drawer.js";
import Dashboard from "./components/dashboard/Dashboard.js";
import Trips from "./components/trips/Trips.js";
import TripDetails from "./components/trips/Trip-Details.js";
import TripPackages from "./components/trips/TripPackages.js"; // eslint-disable-line no-unused-vars
import Drivers from "./components/drivers/Drivers.js";
import Trucks from "./components/trucks/Trucks.js";
import TruckOwners from "./components/truckOwners/Truck-Owners.js";
import TruckOwnerDetails from "./components/truckOwners/Truck-Owner-Details.js";
import ManageUsers from "./components/users/Users.js";
import Settings from "./components/settings/Settings.js";
import Profile from "./components/settings/Profile.js";
import BillingSettings from "./components/settings/Billing.js";
import Package from "./components/settings/package.js";
import Payments from "./components/paymentModule/PaymentModule.js";
import Reconciliation from "./components/paymentModule/Reconciliation.js";
import Withdrawals from "./components/paymentModule/Withdrawals.js";
import BankAccounts from "./components/paymentModule/BankAccounts.js";
import DriverProfile from "./components/drivers/DriverDetails.js";
import TruckDetails from "./components/trucks/Truck-Details.js";
import UserDetails from "./components/users/UserDetails.js";
import Packages from "./components/packages/Packages.js";
import PackagesInfo from "./components/packages/PackageInfo.js";
import Complaints from "./components/complaints/Complaints.js";
import ComplaintDetails from "./components/complaints/ComplaintDetails.js";
import ComplaintStats from "./components/complaints/ComplaintStats.js";
import LocationManagement from "./components/locationManagement/LocationManagement.js";
import ProtectedRoute from "./components/ProtectedRoute.js";
import LocationMapView from "./components/locationMapView/LocationMapView.js";
import PricingAnalytics from "./components/dashboard/PricingAnalytics.js";
import AdminFleetMap from "./components/adminFleetMap/AdminFleetMap.js";
import ProtectionClaims from "./components/protection/ProtectionClaims.js";
import ProtectionClaimDetails from "./components/protection/ProtectionClaimDetails.js";
import ProtectionStats from "./components/protection/ProtectionStats.js";
import ProtectionFundDashboard from "./components/protection/ProtectionFundDashboard.js";
import ProtectionConfig from "./components/protection/ProtectionConfig.js";
import AiInsightsOps from "./components/aiInsightsOps/AiInsightsOps.js";
import CampaignsList from "./components/campaigns/CampaignsList.js";
import CampaignBuilder from "./components/campaigns/CampaignBuilder.js";
import CampaignDetail from "./components/campaigns/CampaignDetail.js";
import LoyaltyTierAdmin from "./components/campaigns/LoyaltyTierAdmin.js";
import ReferralFraudQueue from "./components/campaigns/ReferralFraudQueue.js";
import DimConfig from "./components/campaigns/DimConfig.js";
import EwbBookings from "./components/ewb/EwbBookings.js";
import EwbConfiguration from "./components/ewb/EwbConfiguration.js";
import EwbComplianceDashboard from "./components/ewb/EwbComplianceDashboard.js";
import PricingTiers from "./components/pricing/PricingTiers.js";
// ARM-001 — Agent Role Module
import Agents from "./components/agents/Agents.js";
import AgentDetails from "./components/agents/AgentDetails.js";
// HCT-001 — Heavy Cargo Threshold
import HeavyCargoEnquiries from "./components/packages/HeavyCargoEnquiries.js";

function AppRouter() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LoginWrapper />} />
                <Route path="/app" element={
                    <ProtectedRoute>
                        <ClippedDrawer />
                    </ProtectedRoute>
                }>
                    <Route index element={<Dashboard />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="trips" element={<Trips />} />
                    <Route path="trip-details/:id" element={<TripDetails />} />
                    <Route path="trip-packages/:id" element={<TripPackages />} />
                    <Route path="drivers" element={<Drivers />} />
                    <Route path="driver-details/:id" element={<DriverProfile />} />
                    <Route path="trucks" element={<Trucks />} />
                    <Route path="truck-details/:id" element={<TruckDetails />} />
                    <Route path="truck-owners" element={<TruckOwners />} />
                    <Route path="owner" element={<TruckOwnerDetails />} />
                    {/* ARM-001 — Agent Role Module */}
                    <Route path="agents" element={<Agents />} />
                    <Route path="agent-details/:id" element={<AgentDetails />} />
                    <Route path="users" element={<ManageUsers />} />
                    <Route path="user-details/:id" element={<UserDetails />} />
                    {/* <Route path="delivery-zones" element={<DeliveryZones />} /> */}
                    <Route path="delivery-zones" element={<LocationManagement />} />
                    <Route path="map-viewer" element={<LocationMapView />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="billing-settings" element={<BillingSettings />} />
                    <Route path="package-management" element={<Package />} />
                    <Route path="payments" element={<Payments />} />
                    <Route path="payments/reconciliation" element={<Reconciliation />} />
                    <Route path="payments/withdrawals" element={<Withdrawals />} />
                    <Route path="payments/bank-accounts" element={<BankAccounts />} />
                    <Route path="packages" element={<Packages />} />
                    <Route path="package-info/:id" element={<PackagesInfo />} />
                    <Route path="complaints" element={<Complaints />} />
                    <Route path="complaints/analytics" element={<ComplaintStats />} />
                    <Route path="complaints/:id" element={<ComplaintDetails />} />
                    <Route path="pricing-analytics" element={<PricingAnalytics />} />
                    <Route path="fleet-map" element={<AdminFleetMap />} />
                    <Route path="protection-claims" element={<ProtectionClaims />} />
                    <Route path="protection-claims/:id" element={<ProtectionClaimDetails />} />
                    <Route path="protection-analytics" element={<ProtectionStats />} />
                    <Route path="protection-fund" element={<ProtectionFundDashboard />} />
                    <Route path="protection-config" element={<ProtectionConfig />} />
                    <Route path="ai-insights-ops" element={<AiInsightsOps />} />
                    <Route path="campaigns" element={<CampaignsList />} />
                    <Route path="campaigns/new" element={<CampaignBuilder />} />
                    <Route path="campaigns/:id" element={<CampaignDetail />} />
                    <Route path="campaigns/:id/edit" element={<CampaignBuilder />} />
                    <Route path="loyalty-admin" element={<LoyaltyTierAdmin />} />
                    <Route path="referral-queue" element={<ReferralFraudQueue />} />
                    <Route path="dim-config" element={<DimConfig />} />
                    <Route path="ewb-bookings" element={<EwbBookings />} />
                    <Route path="ewb-config" element={<EwbConfiguration />} />
                    <Route path="ewb-compliance" element={<EwbComplianceDashboard />} />
                    <Route path="pricing-tiers" element={<PricingTiers />} />
                    {/* HCT-001 — Heavy Cargo Threshold enquiries */}
                    <Route path="heavy-cargo-enquiries" element={<HeavyCargoEnquiries />} />
                    <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Route>
            </Routes>
        </Router>
    );
}

const LoginWrapper = () => {
    const authToken = localStorage.getItem('authToken');
    const userData = localStorage.getItem('userData');

    // If user is already authenticated, redirect to dashboard
    if (authToken && userData) {
        return <Navigate to="/app/dashboard" replace />;
    }

    return <LogIn />;
};

export default AppRouter;
